import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconInfoHeatAnalyser$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconInfoHeatAnalyser extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '17b872c5dd5ee963b6ec28af740006ca050cc911', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'a7ca689ba202a7fe7afe41f752396e9918728baa', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '609cbc1dcc0cb3e40c971715b328a4182134e802', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-3 3v-.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5H11a.5.5 0 0 1-.5-.5v-6h-2A.5.5 0 0 1 8 10", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-info-heat-analyser", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-info-heat-analyser"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-info-heat-analyser":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconInfoHeatAnalyser$1);
            }
            break;
    } });
}

const CosmosIconInfoHeatAnalyser = CosmosIconInfoHeatAnalyser$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconInfoHeatAnalyser, defineCustomElement };
